import { bidsColumnDefinitions } from './bidsTable.config';

export const getDefaultColumns = (order: string[]) => {
  const columnMap = new Map(bidsColumnDefinitions.map((col) => [col.id, col]));
  return order.map((id) => columnMap.get(id)).filter((col) => col !== undefined);
};
